var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Layout', {
    staticClass: "home-layout"
  }, [_c('Content', [_c('div', {
    staticClass: "home-form-container"
  }, [_c('div', {
    staticClass: "home-form-title text-center"
  }, [_vm._v("在线申请产品授权")]), _c('Form', {
    staticClass: "home-form",
    attrs: {
      "autocomplete": "off",
      "novalidate": ""
    }
  }, [_c('FormItem', {
    staticStyle: {
      "margin-bottom": "4px"
    },
    attrs: {
      "label": "产品ID号",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "disabled": _vm.loading,
      "placeholder": "请输入产品ID号"
    },
    model: {
      value: _vm.productId,
      callback: function callback($$v) {
        _vm.productId = $$v;
      },
      expression: "productId"
    }
  })], 1), _c('p', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("激活系统升级，激活时提示“该产品id不存在”，请在 "), _c('a', {
    staticClass: "activation-link",
    attrs: {
      "href": "http://activation-v1.os-easy.com",
      "target": "_blank"
    }
  }, [_vm._v("http://activation-v1.os-easy.com")]), _vm._v(" 激活。")]), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.hideFrom,
      expression: "!hideFrom"
    }],
    attrs: {
      "label": "机器码来源",
      "required": ""
    }
  }, [_c('Select', {
    attrs: {
      "disabled": _vm.loading
    },
    model: {
      value: _vm.machineCodeFrom,
      callback: function callback($$v) {
        _vm.machineCodeFrom = $$v;
      },
      expression: "machineCodeFrom"
    }
  }, [_c('Option', {
    attrs: {
      "value": "file"
    }
  }, [_vm._v("文件")]), _c('Option', {
    attrs: {
      "value": "input"
    }
  }, [_vm._v("输入")])], 1)], 1), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.machineCodeFrom === 'file',
      expression: "machineCodeFrom === 'file'"
    }],
    attrs: {
      "label": "机器码(后缀名为mcd格式文件)",
      "required": ""
    }
  }, [_c('ul', {
    staticClass: "activation-file-list"
  }, _vm._l(_vm.fileNames, function (name) {
    return _c('li', {
      key: name
    }, [_c('Button', {
      staticClass: "pull-right btn-remove-activation-file",
      attrs: {
        "disabled": _vm.loading,
        "icon": "ios-trash",
        "size": "small"
      },
      on: {
        "click": function click($event) {
          return _vm.removeFile(name);
        }
      }
    }), _vm._v("\n                            " + _vm._s(name) + "\n                        ")], 1);
  }), 0), _c('Button', {
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.fileInput.click();
      }
    }
  }, [_vm._v("\n                        选择文件 ...\n                        "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.updateFiles
    }
  })])], 1), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.machineCodeFrom === 'input',
      expression: "machineCodeFrom === 'input'"
    }],
    attrs: {
      "label": "机器码",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "disabled": _vm.loading || _vm.hideFrom,
      "placeholder": "请输入机器码"
    },
    model: {
      value: _vm.machineCode,
      callback: function callback($$v) {
        _vm.machineCode = $$v;
      },
      expression: "machineCode"
    }
  })], 1), _c('FormItem', {
    staticStyle: {
      "margin-bottom": "0",
      "text-align": "right"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "disabled": !_vm.isValid()
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("下载激活文件")])], 1)], 1), _c('div', {
    staticClass: "activation-tip-box"
  }, [_c('p', {
    staticClass: "tip-title"
  }, [_vm._v("温馨提示：")]), _c('p', [_vm._v("1. 激活过程中遇到问题请及时联系 "), _c('span', {
    staticClass: "activation-link"
  }, [_vm._v("4001027580")]), _vm._v("，我们的技术人员会及时为你解决问题。")])])], 1), _c('div', {
    staticClass: "copyright-container"
  }, [_vm._v("Copyright © 2011-2016 Wuhan os-easy technology co., ltd")])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };